import React from 'react'
import { X } from 'lucide-react'
import type { MetricSheetState } from '../../../../../services/projectAutofillDraftService.ts'
import ModalOverlay from '../../../../UI/ModalOverlay/ModalOverlay.tsx'
import MetricSheetEditor from './MetricSheetEditor/MetricSheetEditor.tsx'
import type { MetricBudgetSyncPhase } from './projectAutofillCard/hooks/useRubroMetricBudgetSilentSync.ts'
import styles from './BudgetSheetFullscreenModal.module.scss'

type Props = {
  isOpen: boolean
  onClose: () => void
  rubroTitle: string
  state: MetricSheetState | undefined | null
  onChange: (next: MetricSheetState) => void
  disabled: boolean
  budgetSyncPhase?: MetricBudgetSyncPhase
  onMetricIdleCommit?: () => void
}

const MetricSheetFullscreenModal: React.FC<Props> = ({
  isOpen,
  onClose,
  rubroTitle,
  state,
  onChange,
  disabled,
  budgetSyncPhase = 'idle',
  onMetricIdleCommit
}) => {
  const budgetSyncLabel =
    budgetSyncPhase === 'pending' || budgetSyncPhase === 'syncing'
      ? 'Actualizando planilla de cotización…'
      : null
  return (
    <ModalOverlay isOpen={isOpen} onClose={onClose} zIndex={80}>
      <div className={styles.shell}>
        <header className={styles.header}>
          <div className={styles.titleBlock}>
            <h2 className={styles.title}>Cómputo métrico</h2>
            {rubroTitle ? <p className={styles.subtitle}>{rubroTitle}</p> : null}
            {budgetSyncLabel ? <p className={styles.syncStatus}>{budgetSyncLabel}</p> : null}
          </div>
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Cerrar cómputo métrico">
            <X size={22} strokeWidth={2} aria-hidden />
          </button>
        </header>
        {state ? (
          <div className={`${styles.body} ${styles.bodyDocked}`}>
            <MetricSheetEditor
              showHeading={false}
              flushLayout
              dockInModal
              state={state}
              onChange={onChange}
              disabled={disabled}
              onIdleCommit={onMetricIdleCommit}
            />
          </div>
        ) : (
          <div className={styles.emptyBody}>No hay datos de cómputo para mostrar.</div>
        )}
      </div>
    </ModalOverlay>
  )
}

export default MetricSheetFullscreenModal
